var validateCropAgainstConstraints = function validateCropAgainstConstraints(_ref) {
  var crop = _ref.crop,
      constraints = _ref.constraints,
      displayedRatio = _ref.displayedRatio;

  if ((constraints === null || constraints === void 0 ? void 0 : constraints.minWidth) !== undefined) {
    var displayedRatioMinWidth = constraints.minWidth / displayedRatio.ratioX;

    if (crop.width < displayedRatioMinWidth) {
      return false;
    }
  }

  if ((constraints === null || constraints === void 0 ? void 0 : constraints.maxWidth) !== undefined) {
    var displayedRatioMaxWidth = constraints.maxWidth / displayedRatio.ratioX;

    if (crop.width > displayedRatioMaxWidth) {
      return false;
    }
  }

  return true;
};

export default validateCropAgainstConstraints;